import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge, validators } from "tailwind-merge";

const twMerge = extendTailwindMerge<"theme">({
  extend: {
    classGroups: {
      // This makes theme-ANYTHING conflict with other theme-* classes
      theme: [{ theme: [validators.isAny] }],
      // Named layers from packages/tailwind, so a caller's z-100 still replaces them
      z: [
        {
          z: [
            "nav",
            "nav-menu",
            "nav-tooltip",
            "overlay",
            "modal",
            "modal-control",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
